import { useEffect, useState } from "react";

const useBrowserType = () => {
    const [browser, setBrowser] = useState("Unknown");

    useEffect(() => {
        const ua = navigator.userAgent;

        const browser =
            ua.includes("OPR") ? "Opera" :
                ua.includes("Edg") ? "Edge" :
                    ua.includes("Firefox") ? "Firefox" :
                        ua.includes("Chrome") ? "Chrome" :
                            ua.includes("Safari") ? "Safari" :
                                (ua.includes("Trident") || ua.includes("MSIE")) ? "Internet Explorer" :
                                    "Unknown";

        setBrowser(browser);

    }, []);

    return browser;
};

export default useBrowserType;
